document.addEventListener("DOMContentLoaded", function(e){
    document.addEventListener("click", function(e){
        if(e.target.closest("header .header__heading-link")){
            e.preventDefault();
            window.location.reload();
        }
    })
})